export default {
    'sign-log': () =>
        import(
            /* webpackChunkName: "federated/sign-login" */ '@/components/sign-log/index.js'
        )
};
